import fetch from 'cross-fetch';

const baseApiUrl = `https://appetiteapp.chubb.com/api/`; //production API
//const baseApiUrl = `http://stage-appetiteapp.acegrpaccess.com/api/`; //stage API

// Contacts
export const requestContact = () => ({
  type: 'REQUEST_CONTACTS',
});

export const receiveContacts = contacts => ({
  type: 'RECEIVE_CONTACTS',
  contacts,
});

export const fetchContacts = () => {
  const url = baseApiUrl + `contacts`;
  return dispatch => {
    dispatch(requestContact());
    return fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveContacts(data)))
      .catch(error => {
        console.log(`Error: ${error}`);
      });
  };
};

// Industries
export const requestIndustries = () => ({
  type: 'REQUEST_INDUSTRIES',
});

export const receiveIndustries = industries => ({
  type: 'RECEIVE_INDUSTRIES',
  industries,
});

export const fetchIndustries = () => {
  const url = baseApiUrl + `industries`;
  return dispatch => {
    dispatch(requestIndustries());
    return fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveIndustries(data)))
      .catch(error => {
        console.log(`Error: ${error}`);
      });
  };
};

// Products
export const requestProducts = () => ({
  type: 'REQUEST_PRODUCTS',
});

export const receiveProducts = products => ({
  type: 'RECEIVE_PRODUCTS',
  products,
});

export const fetchProducts = () => {
  const url = baseApiUrl + `products`;
  return dispatch => {
    dispatch(requestProducts());
    return fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveProducts(data)))
      .catch(error => {
        console.log(`Error: ${error}`);
      });
  };
};

// Appetites
export const requestAppetites = () => ({
  type: 'REQUEST_APPETITES',
});

export const receiveAppetites = appetites => ({
  type: 'RECEIVE_APPETITES',
  appetites,
});

export const fetchAppetites = () => {
  const url = baseApiUrl + `appetites`;
  return dispatch => {
    dispatch(requestAppetites());
    return fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveAppetites(data)))
      .catch(error => {
        console.log(`Error: ${error}`);
      });
  };
};

// Resources
export const requestResources = () => ({
  type: 'REQUEST_RESOURCES',
});

export const receiveResources = resources => ({
  type: 'RECEIVE_RESOURCES',
  resources,
});

export const fetchResources = () => {
  const url = baseApiUrl + `resources`;
  return dispatch => {
    dispatch(requestResources());
    return fetch(url)
      .then(response => response.json())
      .then(data => dispatch(receiveResources(data)))
      .catch(error => {
        console.log(`Error: ${error}`);
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/actionCreators.js